<template>
    <div class="cemetery-administration">
        <CemeterySectorsStatistic
            v-model="administration"
            :cemeteryCode="code"
            :panelCfg="panelCfg"
            :parentId="parentId"
            :moduleCode="moduleCode"
            :additional="additional"
            :baseTranslateID="baseTranslateID"
        />
    </div>
</template>

<script>
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";

export default {
    mixins: [
        CemeteryElementMixin
    ],
    components: {
        CemeterySectorsStatistic: () => import(/* webpackChunkName: "cemeteries-cemeterysectorsstatistic" */ './CemeterySectorsStatistic'),
    },
    props: {

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    computed: {
        code() {
            return this.value?.code;
        },
        administration() {
            return this.value?.administration ?? {};
        },
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
</style>